import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const updateCateringPaidOrder = async (orderId, orderData) => {
  try {
    const response = await apiClient.post(
      `${API_ENDPOINTS.UPDATE_CATERING_PAID_ORDER}/${orderId}`,
      orderData
    );
    return response;
  } catch (error) {
    console.error("Error updating catering paid order:", error);
    throw error;
  }
};
